import { postRequest } from '../clients/axios';
import { DeletedTourBag } from '../models/DeletedTourBag';

export const postSaveDeletedTourBag = async (data: DeletedTourBag) => {
  const url = 'tourBag/SaveDeletedTourBag';
  const response = await postRequest(url, data);
  return response;
};
